import { FormControl } from '@angular/forms';

export function dependentNonNegativeValidator(dependentContainer: any, dependentFieldName: string) {
    return (control: FormControl): { [key: string]: any } => {
        if (dependentContainer[dependentFieldName] < 0) {
            return { dependentValueNegative: true };
        }
    };
}
